let globalState = {
    myUserId: null,
    isOwner: null,
    isAdmin: null,
    myFolderId: null,
    isNewLeftNav: null,
    isNewTopNav: null,
    myTreeData: null,
    allTreeData: null
};

export const setGlobalState = (newState) => {
    globalState = { ...globalState, ...newState };
};

export const getGlobalState = () => {
    return globalState;
};